import { render } from "./AutomationLandingCard.vue?vue&type=template&id=1f43b228&scoped=true"
import script from "./AutomationLandingCard.vue?vue&type=script&lang=js"
export * from "./AutomationLandingCard.vue?vue&type=script&lang=js"

import "./AutomationLandingCard.vue?vue&type=style&index=0&id=1f43b228&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f43b228"]])

export default __exports__